import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

// SVG Icons for navigation
const LeftArrowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 19L8 12L15 5"
      stroke="#333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RightArrowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5L16 12L9 19"
      stroke="#333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const HeroSection = () => {
  // Slider data
  const sliderData = [
    {
      id: 1,
      title: "Stronger Together",
      description:
        "Together, we can overcome challenges and achieve greater success. Join us to build a supportive community.",
      buttonLabel: "Become a Member",
      buttonLink: "/become-a-member#membership-form",
    },
    {
      id: 2,
      title: "Join the Association",
      description:
        "Become a member today! Gain access to resources, networking, and advocacy that empower your business. Let’s drive change together!",
      buttonLabel: "Become a Member",
      buttonLink: "/become-a-member#membership-form",
    },
    {
      id: 3,
      title: " Not-for-Profit",
      description:
        "As a Not-for-Profit, the MSB Association is dedicated to supporting you business. Your membership helps strengthen our community.",
      buttonLabel: "Become a Member",
      buttonLink: "/become-a-member#membership-form",
    },

    {
      id: 4,
      title: "₤1 Per Day",
      description:
        "Become a member of the MSB Association and together, we can work towards meaningful change while enjoying the benefits of a being together!",
      buttonLabel: "Become a Member",
      buttonLink: "/become-a-member#membership-form",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
    }, 10000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [sliderData.length]);

  // Function to handle slide navigation
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? sliderData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
  };

  return (
    <section className="container-fluid">
      <div className="hero_section hero_financial_consulting parallaxie bg-dark position-relative">
        <div className="row align-items-center ">
          {/* Title and Description */}
          <div className="col-lg-6 mb-3">
            <img src={sliderData[currentIndex].img} alt="" srcset="" />
            <motion.h1
              className="hero_title text-dark mb-0"
              key={sliderData[currentIndex].id}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.5 }}
            >
              {sliderData[currentIndex].title.split(" ").map((word, i) =>
                ["Stronger", "Not-for-Profit", "Association", "₤1"].includes(
                  word
                ) ? (
                  <motion.mark
                    key={i}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{
                      delay: i * 0.2, // Delay for each word
                      duration: 0.5,
                      ease: "easeInOut",
                    }}
                    style={{
                      display: "inline-block",
                      background: "#fff",
                      borderRadius: "10px",
                      marginLeft: "10px",
                    }}
                  >
                    {word}
                  </motion.mark>
                ) : (
                  <span key={i}> {word}</span>
                )
              )}
            </motion.h1>
            {/* Left arrow button */}
          </div>

          {/* Description and Button */}
          <div className="col-lg-6">
            <motion.p
              key={`${sliderData[currentIndex].id}-desc`}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.5 }}
            >
              {sliderData[currentIndex].description}
              <img
                src={sliderData[currentIndex].img2}
                alt=""
                srcset=""
                className="mb-2"
              />
            </motion.p>

            <NavLink
              className="btn bg-primary rounded-pill"
              to={sliderData[currentIndex].buttonLink}
            >
              <span className="btn_label" style={{ color: "#333" }}>
                {sliderData[currentIndex].buttonLabel}
              </span>
              <span className="btn_icon">
                <svg
                  width={20}
                  height={16}
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9H19V7H0V9Z"
                    fill="#333"
                  />
                </svg>
              </span>
            </NavLink>
          </div>

          {/* Right arrow button */}
          <div className="w-25 mt-4">
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                gap: "10px",
              }}
            >
              <button
                className="slider-control left-arrow navigation-btns"
                onClick={handlePrev}
              >
                <LeftArrowIcon />
              </button>

              <button
                className="slider-control right-arrow navigation-btns"
                onClick={handleNext}
              >
                <RightArrowIcon />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* CSS */}
    </section>
  );
};

export default HeroSection;
